/**
 * @file
 * Marker Popup.
 */
/**
 * @typedef {Object} LeafletMarkerPopupSettings
 *
 * @extends {GeolocationMapFeatureSettings}
 *
 * @property {Boolean} infoAutoDisplay
 * @property {Number} maxWidth
 * @property {Number} minWidth
 * @property {Number} maxHeight
 * @property {Boolean} autoPan
 * @property {Boolean} keepInView
 * @property {Boolean} closeButton
 * @property {Boolean} autoClose
 * @property {Boolean} closeOnEscapeKey
 * @property {String} className
 */
(function ($, Drupal) {
  "use strict";
  /**
   * Marker Popup.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches common map marker popup functionality to relevant elements.
   */
  Drupal.behaviors.leafletMarkerIcon = {
    attach: function (context, drupalSettings) {
      Drupal.geolocation.executeFeatureOnAllMaps(
        'leaflet_marker_icon',
        /**
         * @param {GeolocationLeafletMap} map - Current map.
         * @param {LeafletMarkerIconSettings} featureSettings - Settings for current feature.
         */
        function (map, featureSettings) {
          var geolocationLeafletIconHandler = function (currentMarker) {
            var iconUrl;
            if (typeof currentMarker.locationWrapper !== 'undefined') {
              var currentIcon = currentMarker.locationWrapper.data('icon');
            }
            if (typeof currentIcon === 'undefined') {
              if (typeof featureSettings.markerIconPath === 'string') {
                iconUrl = featureSettings.markerIconPath;
              }
              else {
                return;
              }
            }
            else {
              iconUrl = currentIcon;
            }
            var iconOptions = {
              iconUrl: iconUrl,
              shadowUrl: featureSettings.markerShadowPath
            };
            if (featureSettings.iconSize.width && featureSettings.iconSize.height) {
              $.extend(iconOptions, { iconSize: [featureSettings.iconSize.width, featureSettings.iconSize.height] });
            }
            if (featureSettings.shadowSize.width && featureSettings.shadowSize.height) {
              $.extend(iconOptions, { shadowSize: [featureSettings.shadowSize.width, featureSettings.shadowSize.height] });
            }
            if (featureSettings.iconAnchor.x || featureSettings.iconAnchor.y) {
              $.extend(iconOptions, { iconAnchor: [featureSettings.iconAnchor.x, featureSettings.iconAnchor.y] });
            }
            if (featureSettings.shadowAnchor.x || featureSettings.shadowAnchor.y) {
              $.extend(iconOptions, { shadowAnchor: [featureSettings.shadowAnchor.x, featureSettings.shadowAnchor.y] });
            }
            if (featureSettings.popupAnchor.x || featureSettings.popupAnchor.y) {
              $.extend(iconOptions, { popupAnchor: [featureSettings.popupAnchor.x, featureSettings.popupAnchor.y] });
            }
            currentMarker.setIcon(L.icon(iconOptions));
          };
          map.addPopulatedCallback(function (map) {
            $.each(map.mapMarkers, function (index, currentMarker) {
              geolocationLeafletIconHandler(currentMarker);
            });
          });
          map.addMarkerAddedCallback(function (currentMarker) {
            geolocationLeafletIconHandler(currentMarker);
          });
          return true;
        },
        drupalSettings
      );
    },
    detach: function (context, drupalSettings) { }
  };
  Drupal.behaviors.leafletMarkerPopup = {
    attach: function (context, drupalSettings) {
      Drupal.geolocation.executeFeatureOnAllMaps(
        "leaflet_marker_popup",
        /**
         * @param {GeolocationLeafletMap} map - Current map.
         * @param {LeafletMarkerPopupSettings} featureSettings - Settings for current feature.
         */
        function (map, featureSettings) {
          var multipleSNCoord = [];
          var geolocationLeafletPopupHandler = function (currentMarker, multipleSNCoord) {
            if (typeof currentMarker.locationWrapper === "undefined") {
              return;
            }
            var content = currentMarker.locationWrapper.find(".location-content");
            var group_id = currentMarker.locationWrapper.find(".id").text();
            if (group_id) {
              $(currentMarker._icon).addClass('group_' + group_id);
            }
            // * Ajout marqueur sur la carte ruralité
            if ($('.views-id-carte_ruralite').length) {
              var group_class = '';
              if (group_id) {
                group_class = 'group_' + group_id;
              }
              // * Get the value of group_location
              var group_location = currentMarker.locationWrapper.find(".geolocation-latlng").text();
              var parentCoordinates = group_location.split(", ");
              var parentLat = parseFloat(parentCoordinates[0]);
              var parentLng = parseFloat(parentCoordinates[1]);
              var pathOptions = {
                color: '#4a8cff',
                weight: 1,
                // & opacity: .3,
                dashArray: '2, 2',
                dashOffset: '1'
              };
              var path = L.polyline([currentMarker.getLatLng(), [parentLat, parentLng]], pathOptions).addTo(map.markerLayer);
              // * Push group_location into multipleSNCoord
              multipleSNCoord.push(group_location + '|' + group_class);
            }
            // * Fin ajout marqueur
            if (content.length < 1) {
              return;
            }
            var popupOptions = {};
            if (featureSettings.maxWidth) {
              popupOptions.maxWidth = Math.round(featureSettings.maxWidth);
            }
            if (featureSettings.minWidth) {
              popupOptions.minWidth = Math.round(featureSettings.minWidth);
            }
            if (featureSettings.maxHeight) {
              popupOptions.maxHeight = Math.round(featureSettings.maxHeight);
            }
            if (typeof featureSettings.autoPan !== "undefined") {
              popupOptions.autoPan = featureSettings.autoPan;
            }
            if (typeof featureSettings.keepInView !== "undefined") {
              popupOptions.keepInView = featureSettings.keepInView;
            }
            if (typeof featureSettings.closeButton !== "undefined") {
              popupOptions.closeButton = featureSettings.closeButton;
            }
            if (typeof featureSettings.autoClose !== "undefined") {
              popupOptions.autoClose = featureSettings.autoClose;
            }
            if (typeof featureSettings.closeOnEscapeKey !== "undefined") {
              popupOptions.closeOnEscapeKey = featureSettings.closeOnEscapeKey;
            }
            if (featureSettings.className) {
              popupOptions.className = featureSettings.className;
            }
            // * currentMarker.bindPopup(content.html(), popupOptions);
            // * HACK POUR AFFICHER POPUP DANS CARTE GROUP (infoAutoDisplay coché)
            if (featureSettings.infoAutoDisplay) {
              currentMarker
                .bindPopup(content.html(), {
                  autoClose: false,
                  closeOnClick: false,
                })
                .openPopup();
            } else {
              // * OUVRIR OFF-CANVAS CARTE
              currentMarker.on("click", function (e) {
                // & opacité de la polyline
                // & path.setStyle({ opacity: 1 });
                // * Récupérer la valeur du groupe de classes du marqueur actuel
                // if( $('.views-id-carte_ruralite').length){
                // }
                var currentClass;
                if ($('.views-id-carte_ruralite').length) {
                  var currentClass = $(this._icon).attr('class').split(' ').filter(c => c.startsWith("group_"))[0];
                }
                $.each(map.mapMarkers, function (index, currentMarker) {
                  // * Enlever la classe "active" des marqueurs actifs
                  if ($(".sn-marker").length) {
                    $(".sn-marker").removeClass("active");
                  }
                  $(this._icon).removeClass("active");
                  // * Ajouter la classe "active" aux marqueurs du même groupe que le marqueur actuel
                  if (currentClass) {
                    $(this._icon).filter("." + currentClass).addClass("active");
                  }
                  if ($(".sn-marker").length) {
                    $(".sn-marker." + currentClass).addClass("active");
                  }
                });
                // * Ajouter la classe "active" au marqueur actuel
                $(currentMarker._icon).addClass("active");
                // * Masquer l'infobulle s'il est déjà ouvert
                $("#infobulle").removeClass("open");
                // * Récupérer le contenu de l'infobulle
                var infobulle = $("#infobulle .content");
                var groupContent = content.html();
                infobulle.html(groupContent);
                // * Ouvrir l'infobulle en ajoutant la classe "open"
                $("#infobulle").addClass("open");
              });
            }
          };
          map.addPopulatedCallback(function (map) {
            $.each(map.mapMarkers, function (index, currentMarker) {
              geolocationLeafletPopupHandler(currentMarker, multipleSNCoord);
            });
            // * Options de l'icône
            var iconOptions = {
              iconUrl: '/sites/all/themes/custom/theme_asn/dist/images/marker.png',
              iconSize: [24, 24],
              iconAnchor: [12, 12],
            };
            var uniquesSNCoord = [...new Set(multipleSNCoord)];
            $.each(uniquesSNCoord, function (index, groupMarker) {
              // * Récupérer les coordonnées à partir de groupMarker
              var coordinates = groupMarker.split("|")[0];
              // * Séparer les coordonnées en latitude et longitude
              var splitCoordinates = coordinates.split(", ");
              var lat = parseFloat(splitCoordinates[0]);
              var lng = parseFloat(splitCoordinates[1]);
              // * Récupérer la classe de groupe à partir de groupMarker
              var groupClass = groupMarker.split("|")[1];
              // * Définir les options de l'icône
              iconOptions.className = 'sn-marker ' + groupClass;
              var customIcon = L.icon(iconOptions);
              // * Créer un marqueur avec les coordonnées et l'icône personnalisée
              var snMarker = L.marker([lat, lng], { icon: customIcon });
              // * Ajouter le marqueur à la couche de marqueurs de la carte
              snMarker.addTo(map.markerLayer);
              snMarker.setZIndexOffset(10000);
              // * Définir la variable snClickedClass
              var snClickedClass;
              snMarker.on("click", function () {
                $(".sn-marker").removeClass("active");
                $(this._icon).addClass("active");
                var snOrNot = this._icon.classList.contains("sn-marker");
                if (snOrNot) {
                  snClickedClass = $(this._icon).attr('class').split(' ').filter(c => c.startsWith("group_"))[0];
                  var siblingRu = [];
                  $.each(map.mapMarkers, function (index, currentMarker) {
                    var selectedMarker;
                    var markerIcon = $(this._icon);
                    // * Enlever la classe "active" des marqueurs actifs
                    markerIcon.removeClass("active");
                    // * Ajouter la classe "active" aux marqueurs du même groupe que le marqueur actuel
                    markerIcon.filter("." + snClickedClass).addClass("active");
                    // * Selecting a marker based on its icon
                    if (this._icon.classList.contains(snClickedClass)) {
                      selectedMarker = this;
                    }
                    if (typeof selectedMarker !== 'undefined') {
                      siblingRu.push(selectedMarker);
                    }
                  });
                  var firstRu = siblingRu[0];
                  var infobulle = $("#infobulle .content");
                  var content = firstRu.locationWrapper.find(".location-content");
                  var pointRuraliteContent = content.html();
                  infobulle.html(pointRuraliteContent);
                  $("#infobulle").removeClass("open");
                  $("#infobulle").addClass("open");
                }
              });
            });
          });
          // * FERMER OFF-CANVAS CARTE
          $("#infobulle .close-button").click(function () {
            $("#infobulle").removeClass("open");
            $.each(map.mapMarkers, function (index, currentMarker) {
              if ($(".sn-marker").length) {
                $(".sn-marker").removeClass("active");
              }
              $(this._icon).removeClass("active");
            });
          });
          return true;
        },
        drupalSettings
      );
    },
    detach: function (context, drupalSettings) { },
  };
})(jQuery, Drupal);
